import styled from '@emotion/styled'
import { css } from '@emotion/react'

const Container = styled.section`
  --transition-duration: ${({ theme }) => theme.style.transitionTime[400]};

  & {
    width: 100%;
    font-family: Roboto, san-serif;
    line-height: 1.5;
    font-weight: 400;
    background: ${({ theme }) => theme.colors.gray[0]};
    color: ${({ theme }) => theme.colors.gray[600]};
    text-align: center;
    font-size: var(--fs-25);
  }

  .container {
    width: ${({ theme }) => theme.size.width[90]};
    max-width: ${({ theme }) => theme.size.width[900]};
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-flow: row nowrap;
    margin: auto;
  }

  .border {
    width: 100%;
    border-top: 12px solid ${({ theme }) => theme.colors.gray[310]};
  }

  .inner-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-flow: row nowrap;
    width: 100%;
    padding: 0 24px;
  }

  .license-container {
    padding: 16px 0 8px 0;
  }

  .label-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-flow: row nowrap;
    padding: 8px 0 16px 0;
  }

  .label-container > h1 {
    margin: 0 0 0 35px;
  }

  .link-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-flow: row nowrap;
  }

  .link-container > * {
    margin: 0 0 0 30px;
  }

  .hidden-container {
    width: ${({ theme }) => theme.size.width[90]};
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-flow: row nowrap;
    padding: 20px 0;
    margin: auto;
  }

  b {
    font-weight: 500;
  }

  svg {
    width: 0.9em;
  }

  link-container a {
    transition: var(--transition-duration) color;
  }

  link-container a:hover {
    color: ${({ theme }) => theme.colors.secondary[900]};
  }

  link-container a:focus {
    color: ${({ theme }) => theme.colors.secondary[700]};
  }

  link-container a::after {
    content: '';
    width: 0px;
    height: 1px;
    display: block;
    background: black;
    transition: var(--transition-duration) width;
    transform: translate3d(0, calc(-0.5em + 4px), 0);
  }

  link-container a:active {
    color: ${({ theme }) => theme.colors.secondary[700]};
  }

  ${({ theme }) =>
    css(
      theme.size.mq({
        '.container': {
          flexFlow: ['column nowrap', 'column nowrap', 'row nowrap'],
        },
        '.border': {
          borderTopWidth: ['12px', '12px', '12px', '0'],
        },
        '.inner-container': {
          padding: ['0', '0', '0', '0'],
          flexFlow: ['column nowrap', 'column nowrap', 'row nowrap'],
        },
        '.hidden-container': {
          display: ['flex', 'flex', 'none'],
        },
        '.label-container > h1': {
          margin: ['0', '0', '0 0 0 30px'],
        },
        '.label-container': {
          paddingTop: ['8px', '8px', '8px', '16px'],
        },
        '.license-container': {
          paddingBottom: ['8px', '8px', '8px', '16px'],
        },
        '.link-container': {
          display: ['none', 'none', 'flex'],
        },
      }),
    ).styles}}
`

export default Container
